const config = {
  default: {
    name: "Trackmydoc",
    domainName: "trackmydoc.com",
    clientUrl: "https://client.trackmydoc.com",
  },
  "kdmytax.ca": {
    name: "Kdmytax",
    domainName: "kdmytax.ca",
    favicon: "/assets/logo/favicon.ico",
    logo : "/assets/logo/logo.png",
    authLogo : "/assets/logo/auth-logo.png",
    clientUrl: "https://client.kdmytax.ca",
  }
};

const getSiteConfig = () => {
  const hostname = window.location.hostname;
  const matchedKey = Object.keys(config).find((key) => hostname.includes(key));
  return config[matchedKey] || config["default"];
};

const siteConfig = getSiteConfig();

export default siteConfig;
